import React, { useState } from 'react';
import { Subscription } from '../../../../types/subscription';
import { Bot } from 'grts-utils/src/types/Bot';
import { FaChevronRight } from 'react-icons/fa';
import { colors } from '../../../../colors';
import './index.css';
import ManageBalance from './Balance';
import ManageState from './State';

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
}

export enum ManageActions {
  Balance = 'balances',
  State = 'states',
}

const Manage = (props: Props) => {
  const { subscription, bot } = props;

  const [activeAction, setActiveAction] = useState<ManageActions>(
    ManageActions.Balance,
  );

  return (
    <div
      style={{
        display: 'flex',
        marginRight: -30,
        paddingRight: 15,
        flex: 1,
      }}
    >
      <ActionsList
        activeAction={activeAction}
        setActiveAction={setActiveAction}
      />
      <div
        style={{
          overflowY: 'scroll',
          width: '100%',
        }}
      >
        {activeAction === ManageActions.Balance && (
          <ManageBalance
            subscription={subscription}
            maxDecimals={bot?.complexParams?.maxDecimals}
          />
        )}
        {activeAction === ManageActions.State && (
          <ManageState
            subscription={subscription}
            maxDecimals={bot?.complexParams?.maxDecimals}
          />
        )}
      </div>
    </div>
  );
};

export default Manage;

const ActionsList = ({
  activeAction,
  setActiveAction,
}: {
  activeAction: ManageActions;
  setActiveAction: React.Dispatch<React.SetStateAction<ManageActions>>;
}) => {
  return (
    <div
      style={{
        paddingLeft: '10px',
        borderRight: '1px rgb(69, 69, 69) solid',
        paddingTop: '10px',
      }}
    >
      <ActionsListItem
        action={ManageActions.Balance}
        setActiveAction={setActiveAction}
        isActiveAction={activeAction === ManageActions.Balance}
      />
      <ActionsListItem
        action={ManageActions.State}
        setActiveAction={setActiveAction}
        isActiveAction={activeAction === ManageActions.State}
      />
    </div>
  );
};

const ActionsListItem = ({
  action,
  isActiveAction,
  setActiveAction,
}: {
  action: ManageActions;
  isActiveAction: boolean;
  setActiveAction: React.Dispatch<React.SetStateAction<ManageActions>>;
}) => {
  return (
    <div
      style={{
        position: 'relative',
        textTransform: 'capitalize',
        color: isActiveAction ? 'white' : 'gray',
        fontWeight: isActiveAction ? 'bold' : '400',
        cursor: !isActiveAction ? 'pointer' : 'default',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: '75px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      className="actions-list-item"
      onClick={() => setActiveAction(action)}
    >
      {action}
      {isActiveAction && (
        <FaChevronRight
          color={colors.white}
          size={18}
          className={'chevron'}
          style={{ position: 'absolute', right: 0 }}
        />
      )}
    </div>
  );
};

/**
 *     Things we need for manage
        manage balance
            => add balance
            => remove balance
            => move balance
        manage state
            => list of all subs with activate/deactive
            => remove current sub
        Manage exchange
            => current connection list of subs and balances
            => current connection edit of key/secret
            => remove current exchange connection?
            => Add new exchange connection + key/secret
 */
